// Shared by Company Profile and the Gmail template so the displayed defaults
// are the exact URLs used when no company or personal link is saved.
export const COMPANY_SIGNATURE_SOCIALS = [
  { field: 'facebook_url', label: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61584196554458' },
  { field: 'instagram_url', label: 'Instagram', url: 'https://www.instagram.com/lendwise_mortgage' },
  { field: 'linkedin_url', label: 'LinkedIn', url: 'https://www.linkedin.com/company/lendwisemtg' },
  { field: 'tiktok_url', label: 'TikTok', url: 'https://www.tiktok.com/@lendwisemortgage' }
] as const;

type SocialField = typeof COMPANY_SIGNATURE_SOCIALS[number]['field'];
type CompanySocialLinks = Partial<Record<SocialField, string | null>>;

export const DEFAULT_GOOGLE_REVIEW_URL = 'https://g.page/r/CX6bhPcMcZ0QEBM';

export function companySignatureLinks(company: CompanySocialLinks): Record<SocialField, string> {
  return Object.fromEntries(COMPANY_SIGNATURE_SOCIALS.map(({ field, url }) => [
    field, company[field]?.trim() || url
  ])) as Record<SocialField, string>;
}

export function normalizeCompanySocialLink(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  if (!trimmed) {
    return null;
  }
  const url = new URL(trimmed);
  if (url.protocol !== 'https:' || url.username || url.password || !url.hostname.includes('.')) {
    throw new Error('Use a complete HTTPS link.');
  }
  return url.href;
}
